import default_block from 'moodleDir/procollege/lib/vue/default-block-root.vue';

export default {
  routes: [
    {
      path: '/',
      component:default_block,
      name:'default'
    }
  ]
}
